export const exports = [
    {
        id: 13,
        name: "Harar Coffee ",
        category: "Exports",
        description: "This is export standard coffee directly from the hands of the farmers straight to your backyard it is one of the best coffee beans produced in ethiopia",
        image: "/images/products/export3.png"
    },
    {
        id: 14,
        name: "White Sesame Seed",
        category: "Exports",
        description: "This is one of the best Sesame Seeds produced in ethiopia with high regard and production rate",
        image: "/images/products/export7.png"
    },
    {
        id: 15,
        name: "Yirgachefee Coffee",
        category: "Exports",
        description: "This coffee is made in yirgachefee southern part of ethiopia and is one of the best coffee beans produced in the country as even most of ethiopians drink it",
        image: "/images/products/export2.png"
    },
    {
        id: 16,
        name: "Sesame Seed",
        category: "Exports",
        description: "Here are some of the health benefits of Ethiopian sesame seeds:Reduces the risk of heart disease: Sesame seeds are a good source of healthy fats, which can help to reduce the risk of heart disease. Lowers cholesterol: Sesame seeds contain phytosterols, which can help to lower cholesterol levels. Improves blood sugar control: Sesame seeds are a good source of fiber, which can help to improve blood sugar control. Boosts the immune system: Sesame seeds are a good source of antioxidants, which can help to boost the immune system.Protects against cancer: Sesame seeds contain lignans, which have been shown to protect against cancer.",
        image: "/images/products/export5.png"
    },
    {
        id: 17,
        name: "Nuts and Penuts",
        category: "Exports",
        description: "Nuts and penuts are other products we import as they are in high demand",
        image: "/images/products/export6.png"
    },
    {
        id: 18,
        name: "Flowers",
        category: "Exports",
        description: "Ethiopian flowers are known for their high quality and freshness. The flowers are grown in greenhouses, which protect them from the harsh weather conditions. The flowers are also harvested at the peak of their freshness, which ensures that they arrive at their destination in perfect condition.",
        image: "/images/products/export4.png"
    },
    {
        id: 19,
        name: "Sidamo Coffee",
        category: "Exports",
        description: "This coffee is made in sidamo southern part of ethiopia and is one of the best coffee beans produced in the country as even most of ethiopians drink it",
        image: "/images/products/export1.png"
    }
]